import { memo } from 'react';

interface StatBarProps {
  label: string;
  count: number;
  total: number;
  color: string;
}

const StatBar = ({ label, count, total, color }: StatBarProps) => {
  const percentage = total > 0 ? (count / total) * 100 : 0;
  return (
    <div className="flex items-center gap-2">
      <div className="w-20 truncate text-xs text-gray-600">{label}</div>
      <div className="flex-1">
        <div className="h-2 overflow-hidden rounded-full bg-gray-100">
          <div
            className="h-full rounded-full transition-all"
            style={{ width: `${percentage}%`, backgroundColor: color }}
          />
        </div>
      </div>
      <div className="w-12 text-right text-xs text-gray-500">
        {count} ({percentage.toFixed(0)}%)
      </div>
    </div>
  );
};

export default memo(StatBar);
